import React, { useState } from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import { listarTodos, QUERY_LISTAR_TODOS_AGENDAMIENTOS_GUARDERIA } from "../../../services/agendamientosGuarderiaServicios";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { useQuery } from "@tanstack/react-query";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/reservas",
    label: "Reservas por Tipo",
  },
  {
    path: "/reservas/guarderia",
    label: "Reserva Guarderia",
  },
  {
    path: "/reservas/guarderia/listar",
    label: "Listar",
    isActive: true,
  }
];

function ListaAgendamientosGuarderia() {
  // Filtros de query, Eg: ?nombreMascota=Draco&nombrePropietario=Pedro
  const [queryParams, setQueryParams] = useState("");

  const {
    data: paginaAgendamientos,
    isLoading,
    isError,
  } = useQuery({
      queryKey: [
        QUERY_LISTAR_TODOS_AGENDAMIENTOS_GUARDERIA, 
        queryParams
      ],
      queryFn: async () => await listarTodos(queryParams),
    });

  const actualizarFiltroQuery = (filtrosQuery: string) => {
    setQueryParams(filtrosQuery);
  }

  return (
    <>
      <Page
        description="Visualiza y cancela agendamientos de Guardería"
        title="Agendamientos de Guardería"
        breadCrumbs={breadCrumbs}
      >
        <TableSection
          actualizarFiltroQuery={actualizarFiltroQuery}
          isLoading={isLoading} 
          paginaAgendamientos={paginaAgendamientos} />
      </Page>
      {isError && <ServerErrorModal />}
    </>
  );
}

export default ListaAgendamientosGuarderia;
